export enum AccessRulesActionType {
  FETCH_ACCESS_RULES_REQUEST = 'accessRules/FETCH_ACCESS_RULES_REQUEST',
  FETCH_ACCESS_RULES_SUCCESS = 'accessRules/FETCH_ACCESS_RULES_SUCCESS',
  FETCH_ACCESS_RULES_FAILURE = 'accessRules/FETCH_ACCESS_RULES_FAILURE',
}
